import React from "react";
import FilesUploaderModal from "../../../components/files/filesUploaderModal";

class DocumentSignSetup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            uploadingDocument: false
        };
    }

    render() {
        const { checkInAppConfiguration, orgId, eventId, handleChange, templateUrl } = this.props;
        const documentConfig = checkInAppConfiguration.documentSigningConfig || {};

        return (
            <div className="sectionBody">
                <div className='blocksContainer'>
                    <div className='flex w-100'>
                        <div className="sectionBlock mr-25 contained-h">
                            <h2 className='blockHeader'>Signing Configuration</h2>
                            {!documentConfig.boldSignTemplateId && <div className="editorFileInput">

                                <div className="documentActions">
                                    <button 
                                        className="neu prim"
                                        onClick={() => this.setState({ uploadingDocument: true })}
                                    >
                                        <i className="las la-signature mr-10"></i>
                                        Create Signing Template from PDF
                                    </button>
                                    <p className="small mt-10 text-muted">
                                        Click to create a new signature template and configure signature, initial, and date fields on the document.
                                    </p>
                                </div>
                                <FilesUploaderModal
                                    title="PDF of Document to Sign"
                                    links={{
                                        getAssets: `Organizations/${orgId}/events/${eventId}/assets`,
                                        addAssets: `Organizations/${orgId}/events/${eventId}/assets`,
                                    }}
                                    isOpen={this.state.uploadingDocument}
                                    toggle={() => {
                                        this.setState({ uploadingDocument: false });
                                    }}
                                    orgId={orgId}
                                    accept=".pdf"
                                    addFiles={(fileURL) => {
                                        handleChange({ 
                                            documentSigningConfig: {
                                                ...documentConfig,
                                                pdfUrl: fileURL
                                            }
                                        }, true, true);
                                        this.setState({ uploadingDocument: false },  () => this.props.onOpenBoldSignEditor && this.props.onOpenBoldSignEditor());
                                       
                                    }}
                                />
                            </div>}
                        </div>

                        {documentConfig.boldSignTemplateId && templateUrl && (
                            <div className="sectionBlock">                                    
                                <div className="documentActions">
                                    <div className="flex aic jcsb">
                                        <h2 className='blockHeader'>Document Preview</h2>
                                        <div className="flex aic gap10">
                                            <button 
                                                className="neu"
                                                onClick={() => this.props.onOpenBoldSignEditor && this.props.onOpenBoldSignEditor()}
                                            >
                                                Edit Template
                                            </button>
                                            <button 
                                                className="neu danger"
                                                onClick={() => handleChange({ 
                                                    documentSigningConfig: {
                                                        ...documentConfig,
                                                        boldSignTemplateId: "",
                                                        pdfUrl: ""
                                                    }
                                                })}
                                            >
                                                Remove Template
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="documentPreviewContainer">
                                    <iframe
                                        src={templateUrl}
                                        title="Document Preview"
                                        className="documentPreviewFrame"
                                        style={{ width: '100%', height: '500px', border: '1px solid #ddd', borderRadius: '8px' }}
                                    /> 
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default DocumentSignSetup;
